<section class="vsi-section py-5">
    <div class="container py-5">
      <div class="row align-items-center g-5">

        <!-- LEFT COPY -->
        <div class="col-12 col-lg-6">
          <!-- kicker -->
          <div class="d-flex align-items-center gap-3 text-uppercase text-xs fw-semibold vsi-kicker mb-3">
            <span class="vsi-kicker-line"></span>
            <span>{{ vsi_data.kicker }}</span>
          </div>

          <h2 class="vsi-title mb-3">
            {{ vsi_data.title }}
          </h2>

          <p class="vsi-lead mb-4">
            {{ vsi_data.description }}
          </p>

          <a
            :href="vsi_data.cta_link"
            class="vsi-cta d-inline-flex align-items-center gap-2 text-uppercase text-xs fw-semibold text-decoration-none"
          >
            <span>{{ vsi_data.cta_text }}</span>
            <span aria-hidden="true">→</span>
          </a>
        </div>

        <!-- RIGHT “DASHBOARD” -->
        <div class="col-12 col-lg-6">
          <div class="vsi-window shadow-lg mx-lg-auto">
            <!-- top bar -->
            <div class="vsi-window-top d-flex align-items-center px-3 py-2">
              <span class="vsi-dot dot-red"></span>
              <span class="vsi-dot dot-yellow"></span>
              <span class="vsi-dot dot-green"></span>
            </div>

            <div class="p-3 p-md-4">
              <div class="row g-3">
                <!-- metric cards -->
                <div class="col-12 col-md-6">
                  <div class="vsi-card p-3 h-100">
                    <div class="text-uppercase text-xs vsi-card-label mb-2">
                      {{ vsi_metrics[0].label }}
                    </div>
                    <div class="vsi-metric-value">
                      {{ vsi_metrics[0].value }}
                    </div>
                  </div>
                </div>

                <div class="col-12 col-md-6">
                  <div class="vsi-card p-3 h-100">
                    <div class="text-uppercase text-xs vsi-card-label mb-2">
                      {{ vsi_metrics[1].label }}
                    </div>
                    <div class="vsi-metric-value">
                      {{ vsi_metrics[1].value }}
                    </div>
                  </div>
                </div>

                <!-- chart -->
                <div class="col-12">
                  <div class="vsi-card p-3">
                    <div class="text-uppercase text-xs vsi-card-label mb-3">
                      {{ vsi_chart.label }}
                    </div>

                    <div class="vsi-bars d-flex align-items-end">
                      <div
                        v-for="bar in vsi_chart.bars"
                        :key="bar.key"
                        class="vsi-bar-wrap"
                      >
                        <div class="vsi-bar h-75"></div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>

      </div>
    </div>
</section>
